export type HostLaunchKind = 'activity' | 'exam';

export interface HostLaunchIntent {
  kind: HostLaunchKind;
  resourceId: string;
  title: string;
  subjectId?: string;
}

const STORAGE_KEY = 'sala_pending_host_launch';

export function buildHostLaunchUrl(intent: HostLaunchIntent): string {
  const params = new URLSearchParams();
  params.set('launch', intent.kind);
  params.set(intent.kind === 'activity' ? 'draft' : 'exam', intent.resourceId);
  if (intent.subjectId) params.set('subject', intent.subjectId);
  return `/host?${params.toString()}`;
}

export function savePendingHostLaunch(intent: HostLaunchIntent): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  } catch {
    /* ignore */
  }
}

export function loadPendingHostLaunch(): HostLaunchIntent | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as HostLaunchIntent;
    if (!parsed?.kind || !parsed?.resourceId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingHostLaunch(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function parseHostLaunchFromSearch(params: URLSearchParams): HostLaunchIntent | null {
  const kind = params.get('launch');
  if (kind !== 'activity' && kind !== 'exam') return null;
  const resourceId = kind === 'activity' ? params.get('draft') : params.get('exam');
  if (!resourceId) return null;
  return {
    kind,
    resourceId,
    title: '',
    subjectId: params.get('subject') ?? undefined,
  };
}
